/* @flow */

export default class WebsiteLanguage {
  countryCode: string;
  isDefault: boolean;
  locale: string;
}
